import { Auth, AuthStrategy, OktaUserclaim } from './auth.interfaces';
import * as authActions from './auth.actions';

export const AUTH_INITIAL_STATE: Auth = {
  loggedIn: false,
  settingUser: false,
  user: undefined,
  loginFailed: false,
  authStrategy: AuthStrategy.MS,
  userType: undefined,
  isAuthenticated: false,
  authenticationStarted: false,
  authenticationEnded: false,
  oktaUserclaim: undefined
};

/**
 * Ngrx reducer for the auth state, this updates the state for the login/logout success actions
 *
 * @export
 * @param [state=AUTH_INITIAL_STATE]
 * @param action
 * @returns { Auth } Updated state or the default state
 */
export function authReducer(state: Auth = AUTH_INITIAL_STATE, action: authActions.Action): Auth {
  switch (action.type) {
    case authActions.SET_AD_USER: {
      return { ...state, settingUser: true };
    }
    case authActions.LOGIN_SUCCESS: {
      return {
        ...state,
        user: (<authActions.LoginSuccess>action).payload,
        loggedIn: true,
        loginFailed: false,
        settingUser: false,
      };
    }

    case authActions.LOGIN_FAILED: {
      return { ...state, user: undefined, loggedIn: false, loginFailed: true, settingUser: false };
    }

    case authActions.LOGOUT_SUCCESS: {
      return { ...state, user: undefined, loggedIn: false, loginFailed: false, settingUser: false };
    }

    case authActions.SET_USER_TYPE: {
      return { ...state, userType: (<authActions.SetUserType>action).payload };
    }

    case authActions.SET_AUTH_TYPE: {
      return { ...state, authStrategy: (<authActions.SetAuthenticationStrategy>action).payload };
    }

    case authActions.SET_IS_AUTHENTICATED: {
      return { ...state, isAuthenticated: (<authActions.SetIsAuthenticated>action).payload };
    }

    case authActions.SET_AUTHENTICATION_STARTED: {
      return { ...state, authenticationStarted: (<authActions.SetAuthenticationStarted>action).payload };
    }

    case authActions.SET_AUTHENTICATION_ENDED: {
      return { ...state, authenticationEnded: (<authActions.SetAuthenticationEnded>action).payload };
    }

    case authActions.SET_OKTA_USERCLAIM: {
      return { ...state, oktaUserclaim: (<authActions.SetOktaUserclaim>action).payload };
    }

    default: {
      return state;
    }
  }
}

export const isLoggedIn: (Auth) => boolean = (state: Auth) => state.loggedIn;
export const getADUser: (Auth) => adal.User = (state: Auth) => state.user;
export const isSettingUser: (Auth) => boolean = (state: Auth) => state.settingUser;
export const loginFailed: (Auth) => boolean = (state: Auth) => state.loginFailed;

export const getInternalUserToken: (Auth) => string = (state: Auth) => state.user.profile.token;

export const userType: (Auth) => string = (state: Auth) => state.userType;
export const getAuthStrategy: (Auth) => AuthStrategy = (state: Auth) => state.authStrategy;
export const getIsAuthenticated: (Auth) => boolean = (state: Auth) => state.isAuthenticated;
export const getAuthenticationStarted: (Auth) => boolean = (state: Auth) => state.authenticationStarted;
export const getAuthenticationEnded: (Auth) => boolean = (state: Auth) => state.authenticationEnded;
export const getOktaUserclaim: (Auth) => OktaUserclaim = (state: Auth) => state.oktaUserclaim;
